import { DeleteOutlined, EditOutlined, SaveOutlined } from "@ant-design/icons";
import {
  Button,
  Card,
  Col,
  Form,
  Input,
  InputNumber,
  List,
  message,
  Modal,
  Radio,
  RadioGroupProps,
  Row,
  Select,
  Spin,
  Switch,
  Tag,
  TimePicker,
} from "antd";

import { getSupaClient } from "../../lib/supabase";
import {
  ADD_TO_SLACK_URL,
  GITHUB_URL,
  NOTION_URL,
} from "../../utils/constants";
import { useEffect, useState } from "react";

const moment = require("moment-timezone");

// get this in stripe. There is a test vs a live key. replace when we are testing
// get this in stripe. There is a test vs a live price id. replace when we are testing
//
// const stripePriceId = "price_1Icx8sBRYaSwlGbvwIiMyF4M";
// LIVE testing with 0.50 dollars. Comment this when live!
// const stripePriceId = 'price_1IIoIHBRYaSwlGbvuH1I9qrS'
const queryString = require("query-string");

// const stripe = window.Stripe(stripeKey);

export default function SlackWorkspaceSettings() {
  const slackId = localStorage.getItem("slack-id");
  const teamId = localStorage.getItem("team-id");
  const [loading, setLoading] = useState(false);
  const [teamTags, setTeamTags] = useState<any[]>([]);
  const [dailySummary, setDailySummary] = useState(true);
  const [notionWorkspace, setNotionWorkspace] = useState("");
  const [weeklySummary, setWeeklySummary] = useState(true);
  const [floppyDestination, setFloppyDestination] = useState("notion");
  const [codaAPIKey, setCodaAPIKey] = useState("");
  const [codaURL, setCodaURL] = useState("");
  const [airtableAPIKey, setAirtableAPIKey] = useState("");
  const [airtableBase, setAirtableBase] = useState("");
  const [githubRepoName, setGithubRepoName] = useState("");
  const [isEditTagModalVisible, setIsEditTagModalVisible] = useState(false);
  const [isDeleteTagModalVisible, setIsDeleteTagModalVisible] = useState(false);
  const [floppySettingsLoading, setFloppySettingsLoading] = useState(true);
  const [selectedTag, setSelectedTag] = useState<any>({});
  const [teamTimezone, setTeamTimezone] = useState<string | null>(null);

  // eslint-disable-next-line prettier/prettier
  const [weeklyAtRisk, setWeeklyAtRisk] = useState(false);
  const [timezone, setTimezone] = useState<string | null>(null);
  type Settings = {
    work_hours: { start_hour: null; end_hour: null };
    timezone?: any;
    start_time?: any;
    frequency?: any;
    postDay?: any;
  };
  const [settingsObj, setSettingsObj] = useState<Settings>({
    work_hours: { start_hour: null, end_hour: null },
  });
  const { Option } = Select;
  const timezones = moment.tz.names();
  const weekdays = moment.weekdays();
  const [channels, setChannels] = useState<any[]>([]);
  const [selectedChannels, setSelectedChannels] = useState<any[]>([]);
  const supaClient = getSupaClient();
  const [topMembersSettings, setTopMembersSettings] = useState<{
    frequency: string | null;
    postDay: string | null;
    selectedChannel: string | null;
    autoTopMembers: boolean;
    selectedTime: string | null;
  }>({
    frequency: null,
    postDay: null,
    selectedChannel: null,
    autoTopMembers: false,
    selectedTime: null,
  });
  const [botSettings, setBotSettings] = useState({
    botUserName: "",
    botIcon: "",
  });

  const frequencyList = [
    { name: "Every week", value: 7 },
    { name: "Every two weeks", value: 14 },
    { name: "Every month", value: 30 },
  ];
  const onDailySummary = async (checked: boolean) => {
    // console.log(`switch to ${checked}`);
    const { data, error } = await supaClient
      .from("users")
      .update({ settings_daily_slack_digest_subscribed: checked })
      .eq("slack_id", slackId);
    if (data) {
      // console.log("data", data);
      setDailySummary(checked);
      message.success("Daily summary settings saved!");
      window.analytics.track("Weekly summary settings changed");
    }
    if (error) {
      message.info("Please try again");
    }
    return data;
  };

  // Loads the team time zone
  const loadTeamTimezone = async () => {
    const { data, error } = await supaClient
      .from("teams")
      .select("timezone")
      .eq("slack_id", teamId);

    if (data) {
      setTeamTimezone(data[0].timezone);
    }
    if (error) {
      console.log("Error", error);
    }
  };

  const onWeeklySummary = async (checked: boolean) => {
    // console.log(`switch to ${checked}`);
    const { data, error } = await supaClient
      .from("users")
      .update({
        settings_unsubscribed_weekly_email_digest: !checked,
      })
      .eq("slack_id", slackId);
    if (data) {
      // console.log("data", data);
      setWeeklySummary(checked);
      message.success("Weekly summary settings saved!");
      window.analytics.track("Weekly summary settings changed");
    }
    if (error) {
      message.info("Please try again");
    }
    return data;
  };
  /**
   * Purpose: Load user settings
   * Params
   */
  const loadUserSettings = async () => {
    const settings = await supaClient
      .from("users")
      .select(
        "settings_daily_slack_digest_subscribed, settings_unsubscribed_weekly_email_digest, timezone, settings, weekly_at_risk_message_enabled"
      )
      .eq("slack_id", slackId);
    // console.log("settg", settings);
    if (settings.data && settings.data[0]) {
      setDailySummary(settings.data[0].settings_daily_slack_digest_subscribed);
      // since this takes in false to actually enable emails, we set it opposite
      setWeeklySummary(
        !settings.data[0].settings_unsubscribed_weekly_email_digest
      );
      setWeeklyAtRisk(settings.data[0]?.weekly_at_risk_message_enabled);
      setSettingsObj(settings.data[0].settings);
      if (settings.data[0].timezone) {
        setTimezone(settings.data[0].timezone);
      }
    }
    return settings;
  };
  /**
   * Purpose: Load Top member settings
   * Params
   */
  const loadTopMembersSettings = async () => {
    const settings = await supaClient
      .from("teams")
      .select(
        "top_member_post_channel, top_member_post_day,top_member_post_frequency,top_member_post_time,top_member_post_enabled"
      )
      .eq("slack_id", teamId);

    if (settings.data && settings.data[0]) {
      setTopMembersSettings({
        // ...topMembersSettings,
        autoTopMembers: settings.data[0].top_member_post_enabled,
        frequency: settings.data[0].top_member_post_frequency,
        postDay: settings.data[0].top_member_post_day,
        selectedChannel: settings.data[0].top_member_post_channel,
        selectedTime: settings.data[0].top_member_post_time
          ? moment(settings.data[0].top_member_post_time, "hh:mm:ss a").add(
              moment().utcOffset(),
              "minutes"
            )
          : moment(),
      });
    }
    return settings;
  };

  const loadBotPostSettings = async () => {
    const settings = await supaClient
      .from("teams")
      .select("bot_name, bot_icon")
      .eq("slack_id", teamId);
    if (settings.data && settings.data[0]) {
      setBotSettings({
        botUserName: settings.data[0].bot_name,
        botIcon: settings.data[0].bot_icon,
      });
    }
    return settings;
  };

  const loadFloppySettings = async () => {
    const floppySettings = await supaClient
      .from("teams")
      .select("floppy_settings")
      .eq("slack_id", teamId);

    if (floppySettings.error) {
      console.log("Floppy error");
      return null;
    }
    setFloppySettingsLoading(false);
    if (floppySettings.data && floppySettings.data.length) {
      const floppyData = floppySettings.data[0].floppy_settings;
      if (floppyData) {
        setCodaAPIKey(floppyData.coda_api_key);
        setCodaURL(floppyData.coda_url);
        setAirtableAPIKey(floppyData.airtable_api_key);
        setAirtableBase(floppyData.airtable_base);
        setNotionWorkspace(floppyData.notion_workspace_name);
        setGithubRepoName(floppyData.github_repository_name);
        if (floppyData.destination) {
          setFloppyDestination(floppyData.destination);
        }
      }
      return floppyData;
    }
    return null;
  };

  const updateFloppySettings = async (floppySettings: any) => {
    const { data, error } = await supaClient
      .from("teams")
      .update({ floppy_settings: floppySettings })
      .match({ slack_id: teamId });
    if (error) console.log("error in updateFloppySettings", error);
    return data;
  };

  const onFloppyDestinationChanged: RadioGroupProps["onChange"] = async (
    event
  ) => {
    setFloppyDestination(event.target.value);
    updateFloppySettings({
      destination: event.target.value,
      coda_api_key: codaAPIKey,
      coda_url: codaURL,
      airtable_api_key: airtableAPIKey,
      airtable_base: airtableBase,
    });
  };

  const onFloppyCredsChanged = async (key: string, event: any) => {
    const { value } = event.target;
    if (key === "coda_url") {
      setCodaURL(value);
    }
    if (key === "coda_api_key") {
      setCodaAPIKey(value);
    }
    if (key === "airtable_api_key") {
      setAirtableAPIKey(value);
    }
    if (key === "airtable_base") {
      setAirtableBase(value);
    }
    // const newSettings = {
    //   destination: floppyDestination,
    //   coda_api_key: codaAPIKey,
    //   coda_url: codaURL,
    //   airtable_api_key: airtableAPIKey,
    //   airtable_base: airtableBase,
    // };
    // newSettings[key] = value;
    // updateFloppySettings(newSettings);
  };

  const save = async () => {
    const newSettings = {
      destination: floppyDestination,
      coda_api_key: codaAPIKey,
      coda_url: codaURL,
      airtable_api_key: airtableAPIKey,
      airtable_base: airtableBase,
    };
    const { data, error } = await supaClient
      .from("teams")
      .update({ floppy_settings: newSettings })
      .match({ slack_id: teamId });
    if (error) {
      console.log("error in updateFloppySettings", error);
      message.error("Error updating Floppy settings!");
      return error;
    }
    message.success("Updated Floppy settings!");
    window.analytics.track("Saved Coda or Airtable");
    return data;
  };

  /**
   * Save Weekly Risk Toggle
   * @param {bool} checked
   */
  const saveWeekRiskMessage = async (checked: boolean) => {
    const { data, error } = await supaClient
      .from("users")
      .update({ weekly_at_risk_message_enabled: checked })
      .match({ slack_id: slackId });
    setWeeklyAtRisk(checked);
  };

  const loadTeamTags = async () => {
    const { data, error } = await supaClient
      .from("tags")
      .select("id, name, color, description")
      .eq("team", teamId);
    if (data) {
      // console.log("team tags", data);
      setTeamTags(data);
    }
    if (error) {
      console.log("Error", error);
    }
  };

  const loadChannels = async () => {
    const { data, error } = await supaClient
      .from("channels")
      .select("slack_id, name")
      .filter("is_deleted", "eq", false)
      .filter("is_archived", "eq", false)
      .eq("team", teamId);
    if (data) {
      setChannels(data);
    }
    if (error) {
      console.log("Error ======", error);
    }
  };

  const loadChannelsExcluded = async () => {
    const { data, error } = await supaClient
      .from("teams")
      .select("settings_exclude_channels")
      .match({ slack_id: teamId });
    if (data) {
      setSelectedChannels(data[0]?.settings_exclude_channels);
    }
    if (error) {
      console.log("Error", error);
    }
  };

  // check if the user has a strip customer id
  useEffect(() => {
    document.title = "Settings | Dots";
    loadUserSettings();
    loadTeamTags();
    // loadStripeSettings();
    loadFloppySettings();
    loadChannels();
    loadChannelsExcluded();
    loadTopMembersSettings();
    loadBotPostSettings();
    loadTeamTimezone();
  }, []);

  const handleChangeTeamTimezone = (value: string) => {
    setTeamTimezone(value);
  };

  const updateTag = async () => {
    // console.log("update", selectedTag, selectedTag);
    setLoading(true);
    const { data, error } = await supaClient
      .from("tags")
      .update(selectedTag)
      .match({ id: selectedTag.id });
    if (error) {
      setLoading(false);
      message.error("Error editing tag. Please try again");
    }
    if (data) {
      setIsEditTagModalVisible(false);
      await loadTeamTags();
      setLoading(false);
      message.success("Edited successfully");
    }
  };

  // Function to enable force deletion of tags associated to memebers
  // Doesn't take any params
  const deleteTag = async () => {
    setLoading(true);
    // First we delete the user_tag records
    // This is necessary, otherwise we will get an error when deleting the tag
    const { data: userTagData, error: userTagError } = await supaClient
      .from("user_tags")
      .delete()
      .match({ tag: selectedTag.id });
    if (userTagError) {
      setLoading(false);
      setIsDeleteTagModalVisible(false);
      setIsEditTagModalVisible(false);
      message.error("Something went wrong. Please try again");
    }
    if (userTagData) {
      // Remove the actual tag
      const { data, error } = await supaClient
        .from("tags")
        .delete()
        .match({ id: selectedTag.id });

      if (error) {
        setLoading(false);
        setIsDeleteTagModalVisible(false);
        setIsEditTagModalVisible(false);
        console.log("error deleting tag", error);
        message.error("Error deleting tag - Please try again");
      }
      if (data) {
        setIsDeleteTagModalVisible(false);
        setIsEditTagModalVisible(false);
        await loadTeamTags();
        setLoading(false);
        window.analytics.track("Deleted Tag");
        message.success("Deleted successfully");
      }
    }
  };
  const handleChangeTimeZone = (value: string) => {
    setTimezone(value);
  };

  const handleChangeFrequency = (value: any) => {
    setTopMembersSettings({ ...topMembersSettings, frequency: value });
  };

  const handleChangePostDay = (value: string) => {
    setTopMembersSettings({
      ...topMembersSettings,
      postDay: value.toUpperCase(),
    });
  };

  const handleChangeAutoTopMembers = (value: any) => {
    setTopMembersSettings({ ...topMembersSettings, autoTopMembers: value });
  };
  const handleChangeBotName = (e: any) => {
    setBotSettings({ ...botSettings, botUserName: e.target.value });
  };
  const handleChangeBotIcon = (e: any) => {
    setBotSettings({ ...botSettings, botIcon: e.target.value });
  };
  const handleChangeTimeSelected = (_value: any, valueStr: string) => {
    setTopMembersSettings({
      ...topMembersSettings,
      selectedTime: moment(valueStr, "hh:mm:ss a"),
    });
  };
  const handleChangeTimeStart = (value: any) => {
    setSettingsObj({
      ...settingsObj,
      work_hours: {
        ...settingsObj.work_hours,
        start_hour: value,
      },
    });
  };

  const handleChangeTimeEnd = (value: any) => {
    setSettingsObj({
      ...settingsObj,
      work_hours: {
        ...settingsObj.work_hours,
        end_hour: value,
      },
    });
  };

  const handleSubmitSettings = async () => {
    const { data, error } = await supaClient
      .from("users")
      .update({
        timezone,
        settings: settingsObj,
      })
      .eq("slack_id", slackId);
    if (data) {
      message.success("Settings saved!");
    }
    if (error) {
      message.info("Please try again");
    }
  };

  // Sets the team time zone
  const handleSubmitTeamTimezone = async () => {
    const { data, error } = await supaClient
      .from("teams")
      .update({ timezone: teamTimezone })
      .eq("slack_id", teamId);
    if (data) {
      message.success("Team time zone set!");
    }
    if (error) {
      message.info("Please try again");
    }
  };

  const handleTeamSettings = async () => {
    const { data, error } = await supaClient
      .from("teams")
      .update({
        top_member_post_channel: topMembersSettings.selectedChannel,
        top_member_post_day: topMembersSettings.postDay,
        top_member_post_frequency: topMembersSettings.frequency,
        top_member_post_enabled: topMembersSettings.autoTopMembers,
        top_member_post_time:
          topMembersSettings.selectedTime == null
            ? moment().utc().format("hh:mm:ss a")
            : moment.utc(topMembersSettings.selectedTime).format("hh:mm:ss a"),
      })
      .eq("slack_id", teamId);
    if (data) {
      message.success("Settings saved!");
    }
    if (error) {
      message.info("Please try again");
    }
  };
  const handleBotCustomSettings = async () => {
    const { data, error } = await supaClient
      .from("teams")
      .update({
        bot_name: botSettings.botUserName,
        bot_icon: botSettings.botIcon,
      })
      .eq("slack_id", teamId);
    if (data) {
      message.success("Settings saved!");
    }
    if (error) {
      message.info("Please try again");
    }
  };

  const handleChangeChannel = (value: any) => {
    setTopMembersSettings({ ...topMembersSettings, selectedChannel: value });
  };

  const handleSubmitExcludedChannels = async (
    updateChannels: string[] | null
  ) => {
    const { data, error } = await supaClient
      .from("teams")
      .update({
        settings_exclude_channels: updateChannels,
      })
      .match({ slack_id: teamId });
    if (data) {
      message.success("Updated excluded channels!");
    }
    if (error) {
      message.info("Please try again");
    }
  };

  const handleChangeChannels = (value: any) => {
    setSelectedChannels(value);
    handleSubmitExcludedChannels(value);
  };

  return (
    <div>
      <Spin spinning={loading}>
        <Row gutter={[32, 32]}>
          <Col span={12}>
            <Card title="Team settings" bordered={false}>
              <h4>
                Weekly at-risk users message enabled{" "}
                <span>
                  <Switch
                    checked={weeklyAtRisk}
                    onChange={saveWeekRiskMessage}
                  />
                </span>
              </h4>
              <h4 className="mt-7">Exclude channels</h4>
              <p>
                Select channels to exclude:{" "}
                <Select
                  style={{ width: "100%" }}
                  placeholder="Select channels to exclude"
                  allowClear
                  mode="multiple"
                  value={selectedChannels}
                  onChange={handleChangeChannels}
                  showSearch
                  filterOption={(input, option) =>
                    option
                      ? (option["props"] as any).children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      : false
                  }
                >
                  {channels.map(function (item) {
                    return (
                      <Option key={item.slack_id} value={item.slack_id}>
                        {item.name}
                      </Option>
                    );
                  })}
                </Select>
              </p>
              <h4>Time zone</h4>
              <p>
                Select timezone:
                <Select
                  value={teamTimezone}
                  placeholder={!teamTimezone ? "Not set" : teamTimezone}
                  style={{ width: "50%", marginLeft: "10px" }}
                  onChange={handleChangeTeamTimezone}
                  showSearch
                >
                  {timezones.map((val: string) => {
                    return (
                      <Option key={val} value={val}>
                        {val}
                      </Option>
                    );
                  })}
                </Select>
              </p>
              <div className="text-right">
                <Button type="primary" onClick={handleSubmitTeamTimezone}>
                  Save
                </Button>
              </div>
              <h4 className="mt-5">Edit tags</h4>
              <List
                size="large"
                className="skills-options"
                dataSource={teamTags}
                renderItem={(item) => (
                  <List.Item
                    actions={[
                      <Button
                        type="primary"
                        className="-mt-4"
                        icon={<EditOutlined />}
                        size="small"
                        key={item.id}
                        onClick={() => {
                          console.log("item", item);
                          setSelectedTag(item);
                          setIsEditTagModalVisible(true);
                        }}
                      />,
                      <Button
                        type="dashed"
                        danger
                        size="small"
                        icon={<DeleteOutlined />}
                        key={item.id}
                        onClick={() => {
                          setSelectedTag(item);
                          setIsDeleteTagModalVisible(true);
                        }}
                      />,
                    ]}
                  >
                    <List.Item.Meta
                      title={
                        <Tag
                          color={item.color}
                          style={{ margin: 0 }}
                          key={item.id}
                        >
                          {item.name}
                        </Tag>
                      }
                      description={item.description ? item.description : null}
                    />
                  </List.Item>
                )}
              />

              <br />
            </Card>
          </Col>
          <Col span={12}>
            <Card title="Save thread settings" bordered={false}>
              <Spin spinning={floppySettingsLoading}>
                <p>Destination: </p>
                <Radio.Group
                  onChange={onFloppyDestinationChanged}
                  value={floppyDestination}
                  style={{ marginBottom: 20 }}
                >
                  <Radio value="notion">Notion</Radio>
                  <Radio value="coda">Coda</Radio>
                  <Radio value="airtable">Airtable</Radio>
                  <Radio value="github">Github</Radio>
                </Radio.Group>
                {floppyDestination === "notion" ? (
                  <div>
                    <p className="text-center pt-5">
                      {notionWorkspace ? (
                        <p className="text-base text-gray-500">
                          Currently added to workspace {notionWorkspace}{" "}
                        </p>
                      ) : null}
                      <p>
                        <a
                          className="nes-btn is-primary my-10 "
                          href={`${NOTION_URL}/auth/notion`}
                        >
                          <Button type="primary">Add to Notion</Button>
                        </a>
                      </p>
                    </p>
                    <p className="text-base pt-6">
                      1. Duplicate this{" "}
                      <a
                        className="text-purple-800 underline hover:text-gray-900"
                        target="_blank"
                        href="https://dotshq.notion.site/Stored-Slack-threads-Floppy-disk-16bd6ac00ec94beebcdc7c5a03176160"
                        rel="noreferrer"
                      >
                        page
                      </a>{" "}
                      to your Notion workspace.{" "}
                      <p>
                        2. click Add to Notion and select the page that you just
                        duplicated.
                      </p>
                      <p>
                        {" "}
                        PS: Please don&apos;t change the existing column names
                        (but you can add your own columns)
                      </p>
                    </p>
                  </div>
                ) : null}
                {floppyDestination === "coda" ? (
                  <p>
                    <p>
                      Coda API Key:{" "}
                      <Input
                        value={codaAPIKey}
                        onChange={(e) =>
                          onFloppyCredsChanged("coda_api_key", e)
                        }
                      />
                    </p>
                    <p>
                      Coda Table URL:{" "}
                      <Input
                        value={codaURL}
                        onChange={(e) => onFloppyCredsChanged("coda_url", e)}
                      />
                    </p>
                    <Button
                      type="primary"
                      onClick={() => (!codaURL || !codaAPIKey ? "" : save)}
                    >
                      Save
                    </Button>
                  </p>
                ) : null}

                {floppyDestination === "airtable" ? (
                  <p>
                    <p>
                      Airtable API Key:{" "}
                      <Input
                        value={airtableAPIKey}
                        onChange={(e) =>
                          onFloppyCredsChanged("airtable_api_key", e)
                        }
                      />
                    </p>
                    <p>
                      Airtable base:{" "}
                      <Input
                        value={airtableBase}
                        onChange={(e) =>
                          onFloppyCredsChanged("airtable_base", e)
                        }
                      />
                    </p>
                    <Button
                      type="primary"
                      onClick={() =>
                        !airtableBase || !airtableAPIKey ? "" : save
                      }
                    >
                      Save
                    </Button>
                  </p>
                ) : null}

                {floppyDestination === "github" ? (
                  <div>
                    <p className="text-center pt-5">
                      {githubRepoName ? (
                        <p className="text-base text-gray-500">
                          Currently saving to repo <b>{githubRepoName}</b>{" "}
                        </p>
                      ) : null}
                      <p>
                        <a
                          className="nes-btn is-primary my-10 "
                          href={`${GITHUB_URL}`}
                        >
                          <Button type="primary">Add to Github</Button>
                        </a>
                      </p>
                    </p>
                    <p className="text-base pt-6">
                      We currently support only one Github repository, so please
                      choose &quot;Only select repositories&quot; and grant Dots
                      access to one repository. We will store saved threads as
                      Issues in the selected repository.
                    </p>
                  </div>
                ) : null}

                <br />
                <br />
              </Spin>
            </Card>
          </Col>

          <Col span={12}>
            <Card title="Re-authorize" bordered={false} className="mt-20">
              <h4>
                Re authorize slack to access new features (won&#39;t impact your
                existing data)
              </h4>
              <a href={`${ADD_TO_SLACK_URL}/auth/reauthorized/`}>
                <img
                  alt="Reauthorize"
                  height="40"
                  width="139"
                  src="https://platform.slack-edge.com/img/add_to_slack.png"
                  srcSet="https://platform.slack-edge.com/img/add_to_slack.png 1x, https://platform.slack-edge.com/img/add_to_slack@2x.png 2x"
                />
              </a>
            </Card>
          </Col>

          <Col span={12}>
            <Card title="Top Member Setting" bordered={false} className="mt-20">
              <div className="flex">
                <p>Turn On/Off </p>
                <Switch
                  style={{ marginLeft: 10 }}
                  checked={topMembersSettings.autoTopMembers}
                  onChange={handleChangeAutoTopMembers}
                />
              </div>

              <div className="flex">
                <p>Select channels:</p>

                <Select
                  style={{ width: "50%", marginLeft: "10px" }}
                  placeholder="Select channel to post in:"
                  allowClear
                  value={topMembersSettings.selectedChannel}
                  onChange={handleChangeChannel}
                  showSearch
                  filterOption={(input, option) =>
                    (option?.value as string)
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {channels.map(function (item) {
                    return (
                      <Option key={item.slack_id} value={item.slack_id}>
                        {item.name}
                      </Option>
                    );
                  })}
                </Select>
              </div>
              <div className="flex">
                <p>Frequency:</p>
                <Select
                  value={topMembersSettings.frequency}
                  placeholder={
                    !settingsObj.frequency
                      ? "Not set"
                      : topMembersSettings.frequency
                  }
                  style={{ width: "50%", marginLeft: "10px" }}
                  onChange={handleChangeFrequency}
                  showSearch
                >
                  {frequencyList.map(function (val) {
                    return (
                      <Option key={val.value} value={val.value}>
                        {val.name}
                      </Option>
                    );
                  })}
                </Select>
              </div>
              <div className="flex">
                <p>Day of the week:</p>
                <Select
                  value={topMembersSettings.postDay}
                  placeholder={
                    !settingsObj.postDay
                      ? "Not set"
                      : topMembersSettings.postDay
                  }
                  style={{ width: "50%", marginLeft: "10px" }}
                  onChange={handleChangePostDay}
                  showSearch
                >
                  {weekdays.map((val: string) => {
                    return (
                      <Option key={val} value={val}>
                        {val}
                      </Option>
                    );
                  })}
                </Select>
              </div>
              <div>
                <p>
                  Time to post:
                  <TimePicker
                    style={{ width: "50%", marginLeft: "10px" }}
                    value={topMembersSettings.selectedTime as any}
                    onChange={handleChangeTimeSelected}
                  />
                </p>
              </div>
              <div className="text-center">
                <Button type="primary" onClick={handleTeamSettings}>
                  Save
                </Button>
              </div>
            </Card>
          </Col>
          <Col span={12}>
            <Card title="Bot Post Setting" bordered={false} className="mt-20">
              <p>
                You can set a custom bot name and icon here that will be used
                for bot posts. If not set, we use the default Dots bot will be
                used.
              </p>
              <p>
                Bot Username:{" "}
                <Input
                  value={botSettings.botUserName}
                  onChange={handleChangeBotName}
                />
              </p>
              <p>
                Icon Url:{" "}
                <Input
                  value={botSettings.botIcon}
                  onChange={handleChangeBotIcon}
                />
              </p>
              <div className="text-center">
                <Button type="primary" onClick={handleBotCustomSettings}>
                  Save
                </Button>
              </div>
            </Card>
          </Col>
        </Row>

        <Modal
          title={`Delete tag: ${selectedTag.name}`}
          onCancel={() => setIsDeleteTagModalVisible(false)}
          visible={isDeleteTagModalVisible}
          footer={null}
        >
          {selectedTag.name ? (
            <div className="space-y-4">
              <div>
                <p>{`Delete the ${selectedTag.name} tag?`}</p>
                <p>{`This will remove the ${selectedTag.name} tag from all members.`}</p>
              </div>
              <div className="flex flex-row justify-evenly">
                <Button
                  type="dashed"
                  onClick={() => deleteTag()}
                  danger
                  icon={<DeleteOutlined />}
                >
                  Delete
                </Button>
              </div>
            </div>
          ) : (
            "Loading"
          )}
        </Modal>
        <Modal
          title={`Edit tag: ${selectedTag.name}`}
          onCancel={() => setIsEditTagModalVisible(false)}
          visible={isEditTagModalVisible}
          footer={null}
        >
          {selectedTag.name ? (
            <div className="space-y-4">
              <div>
                Name:{" "}
                <Input
                  value={selectedTag.name}
                  onChange={(e) =>
                    setSelectedTag({ ...selectedTag, name: e.target.value })
                  }
                />
              </div>
              <div>
                Description:{" "}
                <Input
                  type="textarea"
                  value={selectedTag.description}
                  onChange={(e) =>
                    setSelectedTag({
                      ...selectedTag,
                      description: e.target.value,
                    })
                  }
                />
              </div>
              <div className="flex flex-row justify-evenly">
                <Button
                  type="dashed"
                  onClick={() => deleteTag()}
                  danger
                  icon={<DeleteOutlined />}
                >
                  Delete
                </Button>
                <Form.Item>
                  <Button
                    type="primary"
                    onClick={() => updateTag()}
                    icon={<SaveOutlined />}
                  >
                    Update
                  </Button>
                </Form.Item>
              </div>
            </div>
          ) : (
            "Loading"
          )}
        </Modal>

        <p id="error-message" />
      </Spin>
    </div>
  );
}
